import React from "react";
import { List, Image } from "semantic-ui-react";
import { SelectItemGeradorCertificado } from "./styles";

const ItemCurso = (props) => {
  if (props.curso.id == props.currentCurso.id) {
    return (
      <List.Item
        style={{ cursor: "pointer" }}
        onClick={() => {
          props.setCurrentCurso({});
          props.setSearchCurso("");
        }}
      >
        <SelectItemGeradorCertificado>
          <Image
            avatar
            src={`https://files.voitto.com.br/cursos/small/${props.curso.url_amigavel}.jpg`}
          />
          <List.Content>
            [{props.curso.id}] - {props.curso.titulo}
          </List.Content>
        </SelectItemGeradorCertificado>
      </List.Item>
    );
  }

  return (
    <List.Item
      id={`curso${props.curso.id}`}
      style={{ cursor: "pointer" }}
      onClick={() => {
        props.setCurrentCurso(props.curso);
        props.setSearchCurso("");
      }}
    >
      <Image
        avatar
        src={`https://files.voitto.com.br/cursos/small/${props.curso.url_amigavel}.jpg`}
      />
      <List.Content>
        [{props.curso.id}] - {props.curso.titulo}
      </List.Content>
    </List.Item>
  );
};

export default ItemCurso;
